<div class="contacts-panel-body-actions">
    @if (newAllowed && hasNewContactPermission && !isConsultantUser) {
        <button class="ace-btn btn-sm btn-primary"
                (click)="newContact()">
            New Contact
        </button>
    }
    @if (hasAssociateExistingPermission) {
        <button class="ace-btn btn-sm btn-primary"
                (click)="associateExisting()">
            Associate Existing
        </button>
    }
</div>
